import React from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const CustomCartIcon = ({ onClick }) => {
  const navigate = useNavigate();
  const { cart } = useCart();
  const cartItemCount = cart?.items?.length || 0;
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 767;

  const handleCartClick = () => {
    if (onClick) onClick();
    navigate("/home/cart");
  };

  return (
    <div
      onClick={handleCartClick}
      style={{
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: isMobile ? 0 : '20px',
        flexShrink: 0,
        width: isMobile ? '100%' : 'auto',
        marginTop: '8px',
      }}
    >
      <div style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <FaShoppingCart size={24} color="#39FFFB" />
        {cartItemCount > 0 && (
          <span style={{
            position: 'absolute',
            top: '-8px',
            right: '-8px',
            background: '#39FFFB',
            color: '#000',
            borderRadius: '50%',
            padding: '2px 6px',
            fontSize: '12px',
            minWidth: '20px',
            textAlign: 'center',
            fontWeight: 'bold',
            zIndex: 1
          }}>
            {cartItemCount}
          </span>
        )}
      </div>
    </div>
  );
};

export default CustomCartIcon; 